import React from 'react'

const CtaSection = (props) => {

// notification function  - STARTSSS
function showNotification(type, message) {
    var notification = document.getElementById('notification');
    notification.className = 'notification ' + type;
    notification.innerHTML = message;
    notification.style.display = 'block';

    setTimeout(function() {
        notification.style.opacity = '0';
        setTimeout(function() {
            notification.style.display = 'none';
            notification.style.opacity = '1';
        }, 2000);
    }, 2000);
}

function sendFormDetails(event){
        var form = document.getElementById("my-form");
        var data = new FormData(event.target);
        fetch(event.target.action, {
          method: form.method,
          body: data,
          headers: {
              'Accept': 'application/json'
          }
        }).then(response => 
            {
          if (response.ok) {
            showNotification('success', 'We will reach you soon');
            form.reset()
          } else {
            response.json().then(data => {
              alert("Please try sometimes later!");
            })
          }
        }
        
        ).catch(error => {
            alert("Please try sometimes later!");
        });
      
    }
    // notification function  - ENDSSS 



    const SubmitHandler = (e) => {
        e.preventDefault()
        sendFormDetails(e);
    }

    return (
        <section className="call-action">
            <div className="container">
                <div className="call-action-inner">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="section-title text-white rmb-35">
                            <h6>get quote</h6>
                            <h2>call for action</h2>
                        </div>
                        </div>
                        <div className="col-lg-6">
                            <form id="my-form" method="post" action="https://formspree.io/f/xovnowka" onSubmit={SubmitHandler} className="subscribe">
                                <input type="email" name="E-Mail" placeholder="enter your mail" required/>
                                <button type="submit" className="theme-btn style-two">subscribe</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CtaSection;